// import components
import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';
import { GridColDef } from '@mui/x-data-grid-pro';

// import hooks
import { useGetOptionsForCLA } from 'hooks/useGetOptionsForCLA';
import { useTranslation } from 'react-i18next';

// import types
import { CLAOption } from '../../CLA/SalaryScales/types';
import { IHolidaysSpecial } from './types';

// import utils
import dayjs from 'dayjs';
import { t } from 'i18next';
import { isNil } from 'ramda';
import { fullDateFormatter } from 'utils/grid';
import * as yup from 'yup';

export const useHolidaysSpecialColumns = () => {
  const { t } = useTranslation('common');

  const claOptions = useGetOptionsForCLA();

  return [
    {
      field: 'date',
      headerName: t('adminPortal.tables.date'),
      minWidth: 150,
      valueFormatter: fullDateFormatter
    },
    {
      field: 'description',
      headerName: t('name'),
      hideable: false,
      flex: 1
    },
    {
      field: 'claId',
      flex: 1,
      headerName: t('adminPortal.tables.cla'),
      type: 'singleSelect',
      valueOptions: claOptions,
      valueFormatter: (params) => singleSelectValueFormatter(params, claOptions)
    }
  ] as GridColDef[];
};

export const convertResponseWithStringDate = (
  response: IHolidaysSpecial[] | undefined
) =>
  response
    ? response.map((data) => {
        return {
          ...data,
          date: dayjs(data.date).isValid() ? dayjs(data.date) : t('invalidDate')
        };
      })
    : [];

export const schemaForHolidaysSpecial = (t) =>
  yup.object({
    date: yup
      .date()
      .required(
        t('validationFieldRequired', { name: t('adminPortal.tables.date') })
      )
      .default(new Date())
      .typeError(
        t('validationFieldRequired', { name: t('adminPortal.tables.date') })
      ),
    description: yup
      .string()
      .required(t('validationFieldRequired', { name: t('name') }))
      .default(''),
    claId: yup
      .number()
      .nullable()
      .required(
        t('validationFieldRequired', { name: t('adminPortal.tables.cla') })
      )
      .typeError(
        t('validationFieldRequired', { name: t('adminPortal.tables.cla') })
      )
  });

export const claDataToOption = (claData: CLAOption[]): Option[] => {
  if (!isNil(claData)) {
    return claData.map((item) => ({
      value: item.claId,
      label: item.code
    }));
  }
  return [];
};
